module.exports = __webpack_public_path__ + "static/header-7a6262ac84af16c9af88844eaa2747a5.png";